
export default {
    namespaced: true,
    state: () => ({
        tableOptions:
        {
            page: 1,
            itemsPerPage: 10,
            sortBy: [ "regdate" ],
            sortDesc: [ true ],
            groupBy: [],
            groupDesc: [],
            multiSort: false,
            mustSort: false 
        },
        search: null,
        status: 'All',
        extendedFilter: {
            EFTheme: {
                label: "Краткое_содержание",
                value: null
            },
            RegNumber: {
                label: "Рег._номер",
                value: null
            },
            RegDateFrom: {
                label: "Дата_регистрации_c",
                value: null
            },
            RegDateTo: {
                label: "Дата_регистрации_по",
                value: null
            },
            Language: {
                label: "Язык_документа",
                value: null
            },
            Executers: {
                label: "Исполнитель",
                value: []
            },
            ResolutionAuthor: {
                label: "Автор_резолюции",
                value: []
            },
            Recipients: {
                label: "Получатель",
                value: []
            },
            JuridicalDocType: {
                label: "Тип_документа",
                value: null
            }
        }
    }),
    mutations: {
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_SEARCH (state, payload) {
            state.search = payload;
        },
        SET_STATUS (state, payload) {
            state.status = payload;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getExtendedFilter: (s) => s.extendedFilter,
        getSearch: (s) => s.search,
        getStatus: (s) => s.status,
    }
}